//================================================================
//  Page: Settings 
//================================================================

//  Purpose: Settings Page & Sidebar

//================================================================

// Libraries
import { Link, useLocation } from 'react-router-dom';

// Tabs
import PermissionSets from './Tabs/PermissionSets';
import AuditLogs from './Tabs/AuditLogs';
import NotFound from '../../../NotFound/NotFound';

// CSS
import './Settings.css';


export default function Settings() {

  //------------------------------------------------------
  //  React Router
  //------------------------------------------------------

  const location = useLocation();

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (

    <div className='Settings-Container'>

      <div className='Settings-Body'>

        {

          // === Permission Sets === //
          location.search.includes('?tab=permissions')  ?

            <PermissionSets></PermissionSets>

          // === Audit Logs === //
          : location.search.includes('?tab=auditlogs') ?

            <AuditLogs></AuditLogs>

          :
            <NotFound></NotFound>

        }
        
      </div>

      {/* ----------------------------------------------- */}
      {/*    SideNav Container                            */}
      {/* ----------------------------------------------- */}

      <div className='Settings-SideNav'>

        <div className='flex flex-col gap-2 py-[25px] px-[30px] border-solid border-gray-200 border-1 h-full min-h-[calc(100vh-132.5px)] overflow-y-auto overflow-x-hidden'>

          {/* ----------------------------------------------- */}
          {/*    HEADER                                       */}
          {/* ----------------------------------------------- */}

          <h4 className='text-[22px] pb-2'>
            Settings
          </h4>

          {/* ----------------------------------------------- */}
          {/*    Menu                                         */}
          {/* ----------------------------------------------- */}

          <div className='flex flex-col gap-3'>

            {/* ==== Admin ==== */}
            <div className='w-full flex flex-col gap-2'>
              <p className='font-semibold text-lg cursor-pointer m-0'>Admin</p>

              {/*  Admin Links */}
              <div className='cursor-pointer'>

                <Link className={`no-underline text-black py-2 px-3 hover:bg-[#E3F1FB] whitespace-nowrap flex items-center text-base ${location?.pathname.includes('/settings') && location?.search.includes('?tab=permissions') ? 'bg-[#E3F1FB]' : 'bg-[#FFFFFF]'}`} to='/settings?tab=permissions&view=agreements'>
                  Permission Sets
                </Link>

              </div>

            </div>

            {/* ==== Audit Logs ==== */}
            {/* Benno 09-07-2025 ~ HIDDEN until next release */}
            <div hidden className='w-full flex flex-col gap-2'>
              <p className='font-semibold text-lg cursor-pointer m-0'>Audit Logs</p>

              {/*  Audit Logs Links */}
              <div className='cursor-pointer'>

                <Link className={`no-underline text-black py-2 px-3 hover:bg-[#E3F1FB] whitespace-nowrap flex items-center text-base ${location?.pathname.includes('/settings') && location?.search.includes('?tab=auditlogs') ? 'bg-[#E3F1FB]' : 'bg-[#FFFFFF]'}`} to='/settings?tab=auditlogs&view=agreements'>
                  View Audit Logs
                </Link>

              </div>

            </div>

          </div>

        </div>

      </div>
  
    </div >

  )

}
